import React, {useEffect, useState} from "react";
import { Link, useNavigate } from "react-router-dom";
import { useLoading } from "../Context/LoadingProvider";
import { useTranslation } from "react-i18next";
import {patrollerService, DailyGoalRequests as DailyGoalRequestInterface} from "../Api/Services/PatrollerService";
import { LongArrowLeftIcon } from "../Components/Icons/LongArrowLeftIcon";
import MySelect from "../Components/MySelect";
import { PlusIcon } from "../Components/Icons/PlusIcon";
import CircleProgress from "../Components/CircleProgress";
import { RingGoalIcon } from "../Components/Icons/RingGoalIcon";

const DailyGoalRequests: React.FunctionComponent<object> = () => {
  const navigate = useNavigate();
  const { startLoading, finnishLoading } = useLoading();
  const { t } = useTranslation();
  const [dailyGoalRequests, setDailyGoalRequests] = useState<DailyGoalRequestInterface[] | null>(null);
  const [inThisMonth, setInThisMonth] = useState<number>(0);
  const [selectedFilter, setSelectedFilter] = useState<number>(-1);

    useEffect(() => {
        startLoading("daily-goal-requests");
        patrollerService.getDailyGoalRequests().then((res) => {
            setDailyGoalRequests(res);
            console.log(res);
            finnishLoading("daily-goal-requests");

            const date = new Date();
            const month = date.getMonth();
            setInThisMonth(res.filter((request) => {
                return new Date(request.date ?? '').getMonth() === month;
            }).length);
        });
        //eslint-disable-next-line
    }, []);

    const filterRequests = (requests: DailyGoalRequestInterface[]) => {
        return dailyGoalRequests?.filter((request) => {
            if (selectedFilter === 1){
                return request.approved_at === null;
            }
            if (selectedFilter === 2){
                return request.approved_at != null && request.approved;
            }
            if (selectedFilter === 3){
                return request.approved_at != null && !request.approved;
            }

            return true;
        })
    };

    


  return (
    <div className="view-container view-container--stretch background-white">
        <div className="view-content">

            <div>
                <div className="navigationbar mb-6">
                    <div className="navigationbar__left">
                        <Link to="/dashboard" className="navigationbar__button text-purple">
                            <LongArrowLeftIcon />
                        </Link>
                    </div>
                    <div className="navigationbar__center">
                        <div className="navigationbar__title text-purple">{t("Goal requests")}</div>
                    </div>
                    <div className="navigationbar__right">
                        
                    </div>
                </div>
            </div>

            <div className="card mb-2">
                <div className="flex gap-4 justify-between items-center">
                    <div>
                        <div className="text-light">{t("This month")}:</div>
                        <div>{inThisMonth}</div>
                    </div>
                    <div>
                        <button
                            onClick={() => { navigate('/create-daily-goal-request') }}
                            className="button button--lg"
                        >
                            {t("Add")}
                            <PlusIcon />
                        </button>
                    </div>
                </div>
                
            </div>

            <div className="mb-4">
                <MySelect 
                options={[
                    { value: -1, label: t("All") },
                    { value: 1, label: t("Pending") },
                    { value: 2, label: t("Approved") },
                    { value: 3, label: t("Declined") },
                ]} 
                value={selectedFilter} 
                onChange={(value) => setSelectedFilter(parseInt(value))}
                />
            </div>

            
                {filterRequests(dailyGoalRequests ?? [])?.map((request, index) => {
                    return (
                        <div key={index} className="card mb-4">
                            <div className="flex mb-4 gap-4 items-center justify-between">
                                <div className="flex gap-2 items-center">
                                    <CircleProgress 
                                        progress={Number(request.goal) === 0
                                            ? 0
                                            : Math.round((Number(request.goal) / 30 * 100))
                                        } 
                                        size={34} 
                                        thickness={4} 
                                        />
                                    <span className="">{request.goal}/30</span>
                                </div>

                                <div>
                                    <div className="flex flex-col items-center justify-center font-10">
                                        {request.approved_at === null && <>
                                            <div className="status-bubble blue">
                                                <span>{t('Pending')}</span>
                                            </div>
                                        </>}
                                        {request.approved_at != null && request.approved && <>
                                            <div
                                                className={
                                                    "status-bubble good"
                                                }
                                            ><span>{t('Approved')}</span></div>
                                            
                                        </>}
                                        {request.approved_at != null && !request.approved && <>
                                            <div
                                                className={
                                                    "status-bubble bad"
                                                }
                                            ><span>{t('Declined')}</span></div>
                                            
                                        </>}
                                    </div>
                                </div>
                            </div>

                            <div className="flex flex-col gap-2">
                                <div className="info-card">
                                    <div className="info-card__title">{t('Date')}</div>
                                    <div className="info-card__value">{request.date}</div>
                                </div>
                            
                                <div className="info-card">
                                    <div className="info-card__title">{t('Note')}</div>
                                    <div className="info-card__value">{request.modification_request ?? "-"}</div>
                                </div>
                            
                                <div className="info-card">
                                    <div className="info-card__title">{t('Supervisor note')}</div>
                                    <div className="info-card__value">{request.modification_response ?? "-" }</div>
                                </div>
                            </div>   
                        </div>
                    )
                })}

                
                {!filterRequests(dailyGoalRequests ?? []) &&
                    <>
                        <div className="no-items-card">
                            <div className="no-items-card__content">
                                <div className="flex justify-center mb-2">
                                    <RingGoalIcon/>
                                </div>
                                <div className="text-center">
                                    {t("There is no goals.")}
                                </div>
                                <div className="text-small text-center">
                                    {t("Add new!")}
                                </div>
                            </div>
                        </div>
                    </>
                }
            
        </div>
      </div>
    
  );
};

export default DailyGoalRequests;
